
export const parseDllError = (err: string) => {
    const errData = JSON.parse(err)

    const tmpErr: any = {
        key: errData.key,
        field: errData.field,
        options: errData.params,  // errData.params.map(prepareOpt).reduce((p: any, c: any) => ({ ...p, ...c }), {})
    }

    return tmpErr
}

export const parseMessages = (messages: {[k: string]: string[]}) => {
    const errors: any = {}
    const { error, warning, info } = messages

    errors['error'] = error.map(parseDllError)
    errors['warning'] = warning.map(parseDllError)
    errors['info'] = info.map(parseDllError)

    return errors
}
